import i18n from 'i18next';

export const columns = [
  {
    id: 'receipt',
    numeric: false,
    disablePadding: true,
    label: i18n.t('dailyDocuments.receipt'),
    needSorting: false,
  },
  {
    id: 'driver',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dailyDocuments.users'),
    needSorting: false,
  },
  {
    id: 'location',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.location'),
    needSorting: false,
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dailyDocuments.documentType'),
    needSorting: false,
  },
  {
    id: 'customer',
    numeric: false,
    disablePadding: true,
    label: i18n.t('dailyDocuments.cusName'),
    needSorting: false,
  },
  {
    id: 'actions',
  },
];

export const eldList = [
  'all',
  'delivery_receipts',
  'dispatch_records',
  'bills_of_landing',
  'receipts',
  'weigh_tickets',
  'communication_records',
  'other_documents',
];
